<template>
    <layout-admin>
        <div slot="sidebar">
            <b-nav tabs class=" pt-3 pr-3 pl-3 sidebar-tab">
                <b-nav-item :to="{name:'pageProduct'}">محصولات</b-nav-item>
                <b-nav-item :to="{name:'pageProductCategory'}">دسته ها</b-nav-item>
            </b-nav>
            <admin-datalist :active="edit" link="fa/v1/product-categories" @itemClick="itemSelected" ref="datalist"/>
        </div>
        <div slot="content">
            <div v-if="showForm">

                <!-- Form -->
                <b-navbar class="px-0 pt-3" type="light" variant="light">
                    <b-navbar-brand href="#">{{title}}</b-navbar-brand>
                    <button-delete title="حذف" class="ml-3 mr-auto "
                                   link="/fa/v1/product-categories"
                                   @deleted="itemDeleted"
                                   v-show="edit" :id="edit"/>
                    <b-button class="btn-outline-primary " @click="backToPageClick">بازگشت</b-button>

                </b-navbar>
                <b-card no-body class="form-card mt-2">
                    <b-tabs card class="">
                        <b-tab title="مشخصات" active>
                            <form-product-category :edit="edit"
                                                   @created="itemCreated"
                                                   @updated="itemUpdated"/>

                        </b-tab>
                        <b-tab title="فایل ها"  :disabled="!edit">
                            <b-button @click="files.push({'id':null})">افزودن</b-button>
                            <hr>
                            <b-row>
                                <b-col lg="6" v-for="(file,index) in files">

                                    <form-category-file @deleted="files.splice(index, 1)"
                                                        :action="'fa/v1/product-categories/'+edit+'/files'"
                                                        :edit="file.id"/>
                                </b-col>
                            </b-row>

                        </b-tab>
                    </b-tabs>

                </b-card>


            </div>
            <div v-else>
                <!-- Dashboard -->

                <b-row>
                    <b-col>

                        <b-navbar class="px-0 pt-3 pb-0" type="light" variant="light">
                            <b-navbar-brand href="#">{{title}}</b-navbar-brand>
                            <b-button class="btn-outline-primary  mr-auto " @click="newItemClick">افزودن</b-button>
                        </b-navbar>


                    </b-col>
                    <b-col class="pr-lg-0">
                        <datachart class=" mt-3" url="/fa/v1/product-categories/chart" ref="datachart"/>
                    </b-col>
                </b-row>


            </div>
        </div>
    </layout-admin>

</template>

<script>

    import MainLayout from "../layouts/MainLayout";
    import Datachart from "../charts/Datachart";
    import ButtonDelete from "../ButtonDelete";
    import Pagination from "../Pagination";
    import AdminDatalist from "../AdminDatalist";
    import LayoutAdmin from "../layouts/LayoutAdmin";
    import StateTotal from "../StateTotal";
    import mixinPage from "../../mixins/mixinPage";
    import FormProductCategory from "../forms/FormProductCategory";
    import FormCategoryFile from "../forms/FormCategoryFile";

    export default {
        mixins: [mixinPage],
        components: {
            FormCategoryFile,
            FormProductCategory,
            StateTotal,
            LayoutAdmin,
            MainLayout,
            Datachart,
            AdminDatalist,
            Pagination,
            ButtonDelete,

        },
        name: "PageProductCategory",
        metaInfo: {
            title: 'دسته ها',
        },
        watch: {
            edit() {
                if (this.edit) {

                    this.axios.get('fa/v1/product-categories/' + this.edit + '/files')
                        .then(({data}) => {
                            this.files = data.data;
                        });

                }
            }
        },
        data: function () {
            return {
                files: [],
                title: 'دسته ها',
                totalLink: "/fa/v1/product-categories/total",
                total: {
                    admins: 0
                }
            }
        },
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/pages/PageProductCategory.vue